//date picker

import './pickdatejs/picker.js'
import './pickdatejs/picker.date.js'
import './pickdatejs/ru_RU.js'

document.addEventListener('DOMContentLoaded', () => {
  const $dateInput = $('.form-field__date')

  $dateInput.pickadate({
    today: '',
    clear: 'Закрыть',
    close: 'Выбрать',
    closeOnSelect: false,
    format: 'dd.mm.yy',
    onOpen: function () {
      if ($dateInput.hasClass('pickerDate__input--target')) {
        $dateInput.pickadate().pickadate('pickerDate').close(true)
      }
    },
    onRender() {
      const picker = this.$root
      const iconArrowRight = '<svg class="icon"><use xlink:href="/img/sprite.svg#icon-arrow-right"></use></svg>'
      picker.find('.pickerDate__nav--prev').html(iconArrowRight)

      picker.find('.pickerDate__nav--next').html(iconArrowRight)

      picker
        .find('.pickerDate__button--close')
        .html(
          '<span class="btn-text">Выбрать</span>' +
            '<span class="btn-icon">' +
            '<svg class="icon"><use xlink:href="/img/sprite.svg#icon-arrow-top-right"></use></svg>' +
            '</span>'
        )
        .addClass('btn btn-bounce btn-bounce-primary')

      picker
        .find('.pickerDate__button--clear')
        .html('Закрыть <svg class="close-icon"><use xlink:href="/img/sprite.svg#icon-close"></use></svg>')
    },
  })
})
